// extracted by mini-css-extract-plugin
module.exports = {"root":"Gallery_root__3GLVj","galleryItemContainer":"Gallery_galleryItemContainer__1URnI","note":"Gallery_note__2QMr4"};